import { initMercadoPago } from "@mercadopago/sdk-react";
import { Payment } from "@mercadopago/sdk-react";
import { IPaymentBrickCustomization } from "@mercadopago/sdk-react/bricks/payment/type";
import React, { FC, useContext, useState } from "react";
import { PaymentResponse } from "../../../types/entities";
import { PaymentApi } from "../../../api/paymentApi";
import {
	MultistepContext,
	MultistepContextValues,
} from "../../../types/context";
import { Skeleton } from "@mui/material";
import { LangContext } from "../../../types/internationalization";
import "./styles.css";

const mercadoPagoKey = process.env.REACT_APP_MP_API_KEY;

interface Props {
	preferences: PaymentResponse;
	updateReservationPayment: Function;
	setPaymentStatus: Function;
}

export const MercadoPagoPayment: FC<Props> = ({
	preferences,
	updateReservationPayment,
	setPaymentStatus,
}) => {
	const { reservation } = useContext(
		MultistepContext
	) as MultistepContextValues;
	const [loading, setLoading] = useState(true);
	const langContext = useContext(LangContext);
	const locale = langContext!.locale;


	initMercadoPago(mercadoPagoKey!, {
		locale: locale === "es-ES" ? "es-AR" : (locale as "en-US" | "pt-BR"),
	});

	const amount = preferences.items.reduce(
		(acc, item) => (acc += item.quantity * item.unitPrice),
		0
	);
	const initialization = {
		amount: amount,
		preferenceId: preferences.id,
		redirectMode: "self",
		payer: {
			email: reservation.customer.email,
		},
	};

	const customization: IPaymentBrickCustomization = {
		paymentMethods: {
			creditCard: "all",
			debitCard: "all",
			mercadoPago: ["wallet_purchase"],
		},
		visual: {
			hideFormTitle: true,
		},
	};

	const onSubmit = async ({ selectedPaymentMethod, formData }) => {
		if (
			selectedPaymentMethod === "credit_card" ||
			selectedPaymentMethod === "debit_card"
		) {
			const paymentApi = new PaymentApi();
			const response = await paymentApi.processPayment(formData);
			setPaymentStatus(response.data.status);
			if (response.data.status === "approved") updateReservationPayment();
		}
	};
	const onError = async (error) => {
		// callback llamado para todos los casos de error de Brick
		console.log(error);
	};
	const onReady = async () => {
		setLoading(false);
	};

	return (
		<>
			{loading && <Skeleton variant="rectangular" width="100%" height={118} />}
			<Payment
				initialization={initialization}
				customization={customization}
				onSubmit={onSubmit}
				onReady={onReady}
				onError={onError}
			/>
		</>
	);
};
